import { createSlice } from "@reduxjs/toolkit";
import { CALL_API } from "../middleware/api";
import ducksHelper from "helpers/ducks";

const name = "files";
const {
  names: { UPDATE, SUCCESS, FAILURE },
  schema,
  defaultState,
  actions: { list, create, destroy }
} = ducksHelper(name);

const slice = createSlice({
  name: name,
  initialState: defaultState,
  reducers: {
    delete: (state, action) => {
      const ids = Object.keys(action.payload.entities[name]);
      ids.forEach(e => {
        delete state.items[e];
      });
      state.updated_at = new Date();
      state.isLoading = false;
    },
    success: (state, action) => ({
      isLoading: false,
      update_at: new Date(),
      items: { ...state.items, ...action.payload.entities[name] }
    })
  }
});

export default slice.reducer;
export { list, create, destroy };
export const update = element => ({
  [CALL_API]: {
    types: [UPDATE, SUCCESS, FAILURE],
    endpoint: `/${name}/${element.get("id")}`,
    schema: [schema],
    method: "PATCH",
    body: element
  }
});
